import Logger, { consoleLog } from './logger'

export default Logger
export { consoleLog }
